import { render, staticRenderFns } from "./RecentActivityFeed.vue?vue&type=template&id=f47569aa&"
import script from "./RecentActivityFeed.vue?vue&type=script&lang=js&"
export * from "./RecentActivityFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports